<div class="status">
  <mat-progress-spinner
    [ngStyle]="{ margin: getMargin() }"
    [diameter]="size"
    class="spinner-class"
    [color]="color"
    [strokeWidth]="strokeWidth"
    [mode]="mode">
  </mat-progress-spinner>
</div>
